export const capacities = [1, 2, 5, 10, 25, 50];
